import css, { SerializedStyles } from '@emotion/css';
import styled from '@emotion/styled';
import { Card, IconButton } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const cssBorderRadius = (theme: ICustomTheme): SerializedStyles =>
  css({
    borderRadius: theme.shape.borderRadius * 2.5,
  });

export const CloseButton = styled(IconButton)<Theme>(({ theme }) => ({
  padding: theme.spacing(0.5),
}));

export const CloseButtonContainer = styled.div<Theme>(({ theme }) => ({
  margin: theme.spacing(-2.5, -2.5, -1.5, 0),
  textAlign: 'right',
}));

export const Img = styled.img<Theme>(({ theme }) => [
  cssBorderRadius(theme),
  {
    maxHeight: '55vh',
    maxWidth: '100%',
  },
]);

export const ImgContainer = styled.div<Theme>(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  minHeight: 300,
  marginBottom: theme.spacing(2),
}));

export const ModalCard = styled(Card)<Theme>(({ theme }) => ({
  margin: 'auto',
  maxWidth: 1000,
  padding: theme.spacing(3.5),
}));

export const RankContainer = styled.div<Theme>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: theme.spacing(1),
  '& div': {
    position: 'unset',
  },
}));
